import development from './development.json';
import production from './production.json';
import standard from './standard.json';
import test from './test.json';

const config = {
  development,
  production,
  test,
};

const stage = process.env.NODE_ENV;
let activeConfig = {};

/**
 * Determines the current environment based on the hostname
 * @returns {string} 'production' or 'test'
 */
const getEnvironmentFromHostname = () => {
  if (typeof window === 'undefined') {
    return 'test'; // Default to test for server-side
  }

  const { hostname } = window.location;
  const prodHostnames = [
    'retailconfigui-prod.nikecloud.com',
    'retailoperations.retailconfigui-prod.nikecloud.com',
  ];

  return prodHostnames.includes(hostname) ? 'production' : 'test';
};

const getConfig = () => {
  if (Object.keys(activeConfig).length === 0) {
    activeConfig = { ...standard, ...config[stage.toLowerCase()] };
  }
  // to run in the test or production environment locally, add "TESTING=true" to the npm run start:test or :prod script
  if (process.env.TESTING) {
    activeConfig.host = development.host;
    activeConfig.redirectUrl = development.redirectUrl;
  }

  // Add environment detection for New Relic
  activeConfig.environment = getEnvironmentFromHostname();

  return activeConfig;
};

// Export for CommonJS (existing usage)
module.exports = getConfig;
// Export named function for ES6 imports
module.exports.getEnvironmentFromHostname = getEnvironmentFromHostname;
